class ApiError{
  constructor(msg){
    this.msg = msg
  }
  static parse(response){
    console.log("ErrorResponse",response)
    return new ApiError(response.message || "Server Error")
  }
}


export default ApiError



// WEBPACK FOOTER //
// ./src/models/api-error.js